/**
 * CleaningFrequency enum - synchronized with Prisma schema
 * @see prisma/schema.prisma CleaningFrequency enum
 *
 * WEEKLY_DAYS: due on each selected weekday (`scheduledDays`).
 * BIWEEKLY / MONTHLY: rolling deadline from the last cleaning record
 * (+14 days / +1 calendar month); `scheduledDays` stays empty.
 */
export enum CleaningFrequency {
  WeeklyDays = 'WEEKLY_DAYS',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
}

export const CLEANING_FREQUENCY_VALUES = [
  CleaningFrequency.WeeklyDays,
  CleaningFrequency.Biweekly,
  CleaningFrequency.Monthly,
] as const;

export function isPeriodicCleaningFrequency(frequency: CleaningFrequency | undefined): boolean {
  return frequency === CleaningFrequency.Biweekly || frequency === CleaningFrequency.Monthly;
}
